/**
 * An identity function.
 * @param {any} value
 * @returns Always returns the input value.
 */
export default (value) => value;
